import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _templateObject;
import React, { useState } from 'react';
import { css, Global } from '@emotion/react';
import ReactDOM from 'react-dom';
import { notifyError } from '../Notification/NotificationHost';
import { overlayAnimationDurationMS } from '../Overlay/Overlay.styled';
import { useTranslate } from '../util';
import { ErrorBoundary } from '../util/ErrorBoundary';
import { createPortal, destroyPortal, noPrintClassName } from '../util/renderPortal';
export function useDialogPortal() {
  var t = useTranslate();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeDialog = _useState2[0],
    setActiveDialog = _useState2[1];
  function disposeDialog(dialog) {
    setActiveDialog(_objectSpread(_objectSpread({}, dialog), {}, {
      disposing: true
    }));
    var removalTimeout = overlayAnimationDurationMS;
    setTimeout(function () {
      setActiveDialog(undefined);
      destroyPortal(dialog.domNode);
    }, removalTimeout);
  }
  function showDialog(element) {
    var domNode = createPortal();
    var isClosing = false;
    var dialog = {
      element: element,
      disposing: false,
      domNode: domNode,
      onDismiss: function onDismiss() {
        disposeDialog(dialog);
        if (!isClosing && element.props.onDismiss) {
          isClosing = true;
          element.props.onDismiss();
        }
      },
      onCloseSuccess: function onCloseSuccess(value) {
        disposeDialog(dialog);
        if (!isClosing && element.props.onCloseSuccess) {
          isClosing = true;
          element.props.onCloseSuccess(value);
        }
      }
    };
    setActiveDialog(dialog);
  }
  function _onError(dialog) {
    var _dialog$onDismiss;
    notifyError(t('citrix-ui:generic_error_message'));
    (_dialog$onDismiss = dialog.onDismiss) === null || _dialog$onDismiss === void 0 ? void 0 : _dialog$onDismiss.call(dialog);
  }
  return {
    portal: function portal() {
      if (!activeDialog) {
        return;
      }
      var element = /*#__PURE__*/React.cloneElement(activeDialog.element, {
        onDismiss: activeDialog.onDismiss,
        onCloseSuccess: activeDialog.onCloseSuccess,
        isOpen: !activeDialog.disposing
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Global, {
        styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tbody {\n\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t@media print {\n\t\t\t\t\t\t\t\t\toverflow: visible;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.", " {\n\t\t\t\t\t\t\t\t@media print {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t"])), noPrintClassName)
      }), /*#__PURE__*/React.createElement(ErrorBoundary, {
        onError: function onError() {
          return _onError(activeDialog);
        }
      }, /*#__PURE__*/ReactDOM.createPortal(element, activeDialog.domNode)));
    },
    showDialog: showDialog
  };
}